import { Stack } from "@mui/material";
import { fDate } from "../../../utils/formatTime";
import NoSignatureImg from "../../../assets/no-signature.png";

const Footer = (_props) => {
    const { candidateData, className } = _props
    return (
        <>
            {/* for web preview */}
            <div className="print-web">
                <Stack
                    direction={{
                        lg: "row",
                        md: "row",
                        sm: "row",
                        xs: "column",
                    }}
                    justifyContent="space-between"
                    // className="textual"
                    mt={5}
                >
                    <div className={`${className}--textinfo`}>
                        {/* <div className={`${className}--text`}>
                            <p>
                            Submitted Date: <span>06/02/2023</span>
                            </p>
                        </div> */}
                        <div className={`${className}--text`}>
                            <p>
                                Place of filling form:{" "}
                                <span className={`${className}--textspan`}>
                                    {candidateData?.application_filling_place?.length >
                                        0
                                        ? candidateData?.application_filling_place
                                        : "-"}
                                </span>
                            </p>
                        </div>
                        <div className={`${className}--text`}>
                            <p>
                                Submitted Date & Time :{" "}
                                <span>
                                    {candidateData?.payment_status === "Success" &&
                                        candidateData?.transaction_date
                                        ?
                                        candidateData?.transaction_date
                                        : "-"}
                                </span>
                            </p>
                        </div>
                        <div className={`${className}--text`}>
                            <p>
                                Print Date :{" "}
                                <span>{fDate(new Date(), "dd/MM/yyyy")}</span>
                            </p>
                        </div>
                    </div>
                    <div className={`${className}--signatureinfo`}>
                        <div className={`${className}--signature`}>
                            <img
                                src={candidateData?.candidate_signature
                                    ? candidateData?.candidate_signature
                                    : NoSignatureImg}
                                alt="signature"
                                className={`${className}--img`}
                            />
                        </div>
                        <p className={`${className}--signaturetext`}>
                            Signature of Candidate
                        </p>
                    </div>
                </Stack>
            </div>
            {/* for print preview */}
            <div className="print-view mt">
                <div className="d-flex alignTop j-btw">
                    <div className={`${className}--textinfo`}>
                        {/* <div className={`${className}--text`}>
                            <p>
                            Submitted Date: <span>06/02/2023</span>
                            </p>
                        </div> */}
                        <div className={`${className}--text`}>
                            <p>
                                Place of filling form:{" "}
                                <span className={`${className}--textspan`}>
                                    {candidateData?.application_filling_place?.length >
                                        0
                                        ? candidateData?.application_filling_place
                                        : "-"}
                                </span>
                            </p>
                        </div>
                        <div className={`${className}--text`}>
                            <p>
                                Submitted Date & Time :{" "}
                                <span>
                                    {candidateData?.payment_status === "Success" &&
                                        candidateData?.transaction_date
                                        ?
                                        candidateData?.transaction_date
                                        : "-"}
                                </span>
                            </p>
                        </div>
                        <div className={`${className}--text`}>
                            <p>
                                Print Date :{" "}
                                <span>{fDate(new Date(), "dd/MM/yyyy")}</span>
                            </p>
                        </div>
                    </div>
                    <div className={`${className}--signatureinfo`}>
                        <div className={`${className}--signature`}>
                            <img
                                src={candidateData?.candidate_signature
                                    ? candidateData?.candidate_signature
                                    : NoSignatureImg}
                                alt="signature"
                                className={`${className}--img`}
                            />
                        </div>
                        <p className={`${className}--signaturetext`}>
                            Signature of Candidate
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer;